import React from 'react';

const PlusWcag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 523.16 523.16"><defs><style>{`.cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#2c5299;}`}</style><clipPath id="clip-path" transform="translate(0 0)"><rect class="cls-1" width="523.16" height="523.16"/></clipPath></defs><title>Większy rozmiar czcionki</title><g id="Warstwa_2" data-name="Warstwa 2"><g id="Warstwa_1-2" data-name="Warstwa 1"><g class="cls-2"><path class="cls-3" d="M446.55,76.62A261.58,261.58,0,0,0,76.61,446.55,261.58,261.58,0,0,0,446.55,76.62m-363,220v-70h143v-143h70v143h143v70h-143v143h-70v-143Z" transform="translate(0 0)"/></g></g></g></svg>
    )
}

export default PlusWcag;